module.exports = __webpack_public_path__ + "static/media/tessellana_veyseli_BD_003_APA.262dc996.png";